import { render, staticRenderFns } from "./ListsManagerDialog.vue?vue&type=template&id=44c8c2ab"
import script from "./ListsManagerDialog.vue?vue&type=script&lang=ts"
export * from "./ListsManagerDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports